import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Modal, ModalContent } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import Form from 'View/schedule-generate/section/form';
import ScheduleGenerateProvider, { useScheduleGenerateState } from 'View/schedule-generate/state';
import Head from 'View/schedule-generate/section/head';
import Loading from 'View/schedule-generate/section/loading';
import GenerateResult from 'View/schedule-generate/section/generate-result';
import Progress from 'View/schedule-generate/section/progress';
import { defaultValuesForm } from 'View/schedule-generate/const';

import styles from './styles.module.css';

const ScheduleGenerate = () => {
  const form = useForm({ defaultValues: defaultValuesForm });
  const { viewState } = useScheduleGenerateState();
  const navigate = useNavigate();

  const accessPermission = getMenuPermissions('schedule', 'schedule');

  useEffect(() => {
    if (isEmpty(accessPermission)) navigate('/forbidden');
  }, [accessPermission]); // eslint-disable-line

  return (
    <Modal isOpen={true} size={'full'}>
      <ModalContent width={'100%'} className={styles['modal__container--content']}>
        <Progress />
        <Head />
        <Condition children={<Form form={form} />} statement={viewState === 'form'} />
        <Condition children={<Loading />} statement={viewState === 'loading'} />
        <Condition children={<GenerateResult />} statement={viewState === 'generate-result'} />
      </ModalContent>
    </Modal>
  );
};

const ScheduleGenerateContainer = () => {
  return <ScheduleGenerateProvider children={<ScheduleGenerate />} />;
};

export default ScheduleGenerateContainer;
